import React, { useState } from 'react';

import { Input } from 'ui';

import { kwhInputText } from 'utils/decimalInput';

type InputProps = React.InputHTMLAttributes<HTMLInputElement>;

interface KwhInputProps extends Omit<InputProps, 'value'> {
  value: string | number | null | undefined;
  /** Input estilizado da tela; por padrão, o `Input` do `ui`. */
  component?: React.ComponentType<InputProps>;
}

/**
 * Campo editável de kWh no padrão de números (nov/2026): fora de edição mostra
 * inteiro com milhar ("13.872"); em edição mostra o valor exato, com vírgula.
 *
 * Só a EXIBIÇÃO muda: `value` e o `onChange` continuam com o texto cru da tela,
 * então o dado salvo não é arredondado. Formatar o estado da tela seria um bug
 * duplo: 13872,37 viraria 13872 ao salvar, e `parseDecimalInput("13.872")` lê
 * 13,872. Usado na confirmação do upload e nos modais de planta e de histórico.
 */
export const KwhInput = ({
  value,
  component: Component = Input,
  onFocus,
  onBlur,
  ...rest
}: KwhInputProps) => {
  const [focused, setFocused] = useState(false);

  return (
    <Component
      {...rest}
      value={kwhInputText(value, focused)}
      onFocus={(e) => {
        setFocused(true);
        onFocus?.(e);
      }}
      onBlur={(e) => {
        setFocused(false);
        onBlur?.(e);
      }}
    />
  );
};
